import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ClockRefresh = function ClockRefresh(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.4532 12.8928c-.2778 2.6099-1.7565 5.0556-4.2035 6.4684-4.0655 2.3472-9.264.9543-11.6113-3.1112l-.25-.433m-.8422-4.7099c.2778-2.6099 1.7566-5.0556 4.2035-6.4684 4.0655-2.3472 9.2641-.9542 11.6113 3.1113l.25.433M3.4932 18.0659l.732-2.732 2.732.732m10.085-8.132 2.7321.7321.732-2.732M11.9997 7.5V12l2.5 1.5"
    })
  }));
};
export default ClockRefresh;